import type { Component, ComputedRef, InjectionKey } from 'vue';

/** createAxApp 옵션으로 주입. 일반 el-menu 트리에서 제외하고 사이드바 하단에 고정 표시한다. */
export const SIDEBAR_PINNED_MENU_CODES_KEY: InjectionKey<string[]> =
  Symbol('sidebarPinnedMenuCodes');

/**
 * createAxApp 옵션으로 주입. 해당 folder code 아래 leaf 메뉴 전체를 도크로 이동한다.
 * (예: MES `mes.pop` 그룹 → POP 현장 화면 8종)
 */
export const SIDEBAR_PINNED_MENU_GROUP_CODES_KEY: InjectionKey<string[]> = Symbol(
  'sidebarPinnedMenuGroupCodes',
);

/** 도크 구역 상단 라벨 (예: `POP`). 미지정 시 숨김. */
export const SIDEBAR_PINNED_MENU_SECTION_LABEL_KEY: InjectionKey<string> = Symbol(
  'sidebarPinnedMenuSectionLabel',
);

/**
 * 그룹 고정 메뉴를 개별 카드 대신 단일 런처 버튼 + popover 로 표시할 때의 버튼 라벨.
 * (예: MES `POP/모니터링`)
 */
export const SIDEBAR_PINNED_MENU_LAUNCHER_LABEL_KEY: InjectionKey<string> = Symbol(
  'sidebarPinnedMenuLauncherLabel',
);

/** menu.code → 미읽음 등 배지 숫자. Tier 앱에서 provide (예: ERP 채팅 totalUnread). */
export type SidebarPinnedMenuBadges = Readonly<Record<string, number>>;

export const SIDEBAR_PINNED_MENU_BADGES_KEY: InjectionKey<ComputedRef<SidebarPinnedMenuBadges>> =
  Symbol('sidebarPinnedMenuBadges');

/** SidebarPinnedMenu 도크에 추가로 렌더할 Tier 전용 버튼 (예: MES Agent). */
export interface SidebarDockExtraProps {
  collapsed: boolean;
}

export const SIDEBAR_DOCK_EXTRA_KEY: InjectionKey<Component<SidebarDockExtraProps> | null> =
  Symbol('sidebarDockExtra');
